function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;

function o(e) {
  var r, i;
  var n = (r = e.innerText) != null ? r : "",
      t = e.cloneNode(!0);
  if (!(t instanceof HTMLElement)) return n;
  var u = !1;

  var _iterator = _createForOfIteratorHelper(t.querySelectorAll('[hidden],[aria-hidden],[role="img"]')),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var f = _step.value;
      f.remove(), u = !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var l = u ? (i = t.innerText) != null ? i : "" : n;
  return a.test(l) && (l = l.replace(a, "")), l;
}

function g(e) {
  var n = e.getAttribute("aria-label");
  if (typeof n == "string") return n.trim();
  var t = e.getAttribute("aria-labelledby");

  if (t) {
    var u = t.split(" ").map(function (l) {
      var r = document.getElementById(l);

      if (r) {
        var i = r.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : o(r).trim();
      }

      return null;
    }).filter(Boolean);
    if (u.length > 0) return u.join(", ");
  }

  return o(e).trim();
}

export { g as getTextValue };